import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { successStaleTime } from '@/shared/api/utils/query'
import { time } from '@/shared/datetime/utils/time'

import { fetchMe, getAzureSignupDetails } from './api'

export const userKeys = {
	all: ['user'] as const,
	me: () => [...userKeys.all, 'me'],
}

export const userQueries = {
	me: () =>
		queryOptions({
			queryKey: userKeys.me(),
			queryFn: ({ signal }) => fetchMe(signal),
			// Data will live in memory for 15 minutes after being fetched
			gcTime: time(15, 'm'),
			// Data will be considered stale after 5 minutes
			staleTime: ({ state }) => successStaleTime(state, 5, 'm'),
			meta: { tenantAgnostic: true },
		}),
}

export const useMe = () => {
	return useSuspenseQuery(userQueries.me())
}

export const authKeys = {
	all: ['auth'] as const,
	azure: () => [...authKeys.all, 'azure'] as const,
	azureSignupDetails: (token: string) =>
		[...authKeys.azure(), 'signup-details', token] as const,
}

export const authQueries = {
	azureSignupDetails: (token: string, enabled = false) =>
		queryOptions({
			queryKey: authKeys.azureSignupDetails(token),
			queryFn: ({ signal }) => getAzureSignupDetails(token, signal),
			// Data will live in memory for 15 minutes after being fetched
			gcTime: time(3, 'm'),
			// Data will be considered stale after 5 minutes
			staleTime: ({ state }) => successStaleTime(state, 5, 'm'),
			enabled,
		}),
}

export const useAzureSignupDetails = (token: string, enabled = false) => {
	return useQuery(authQueries.azureSignupDetails(token, enabled))
}
